import * as React from 'react'
import i18next from 'i18next'
import { Spinner } from '../Spinner'

/** Opaque app-boot gate, shown until the initial session/workspace load settles. */
export const FullScreenLoader = () => (
  <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-50">
    <Spinner size="lg" />
    <p className="mt-4 text-sm text-gray-500">{i18next.t('loading.text')}</p>
  </div>
)
